import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import type { ContractorSearchInterfacePropsType } from '../..';
import { CONSTRUCTION_TYPE_LIST } from './consts/constructionTypeList';
import { WallAndRoofSvg } from './assets/WallAndRoof.svg';

const { tablet, mobile } = mediaQueries();

const KEY_NAME = 'SearchByWallAndRoofConstructionType';
const PARAM_NAME = 'preferredSearchCriteria';

export type SearchByReviewPropsType = Merge<ContractorSearchInterfacePropsType & {
  onApplyHandler: () => void;
}>;

export const SearchByWallAndRoofConstructionType = (props: SearchByReviewPropsType) => {
  const { userAnswers, commonAnswerHandler, onApplyHandler: onApplyHandlerFromProps } = props;
  const onApplyHandler = React.useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    const { value } = event.currentTarget;
    commonAnswerHandler(PARAM_NAME, value || '');

    userAnswers.push({
      keyName: 'constructionParts',
      paramName: 'constructionParts',
      question: '工事箇所は',
      answer: '外壁と屋根',
      value: '外壁と屋根',
    });

    userAnswers.push({
      keyName: 'wallConstructionType',
      paramName: 'wallConstructionType',
      question: '外壁の工事種別は',
      answer: value || '',
      value: value || '',
    });

    userAnswers.push({
      keyName: 'roofConstructionType',
      paramName: 'roofConstructionType',
      question: '屋根の工事種別は',
      answer: value === '張り替え' ? '葺き替え・重ね葺き' : value,
      value: value === '張り替え' ? '葺き替え・重ね葺き' : value,
    });

    userAnswers.push({
      keyName: 'constructionCategory',
      paramName: 'constructionCategory',
      question: '',
      answer: value === '張り替え' ? '6' : '5',
      value: value === '張り替え' ? '6' : '5',
    });

    onApplyHandlerFromProps();
  }, [commonAnswerHandler, onApplyHandlerFromProps, userAnswers]);

  return (
    <div
      css={css`
        width: 100%;

        ${tablet(() => css`
          max-width: 568px;
          margin-inline: auto;
          padding: 0 1em;
        `)}
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: 0 6px;
          margin-bottom: 24px;

          ${mobile(({ setAutomaticDesignBasedSize }) => css`
            margin-bottom: ${setAutomaticDesignBasedSize(24, 20)};
          `)}
        `}
      >
        <div
          css={css`
            font-size: 0;
            width: 26px;

            ${mobile(({ setAutomaticDesignBasedSize }) => css`
              width: ${setAutomaticDesignBasedSize(26, 23)};
            `)}
          `}
        >
          <WallAndRoofSvg />
        </div>
        <p
          css={css`
            color: #000;
            font-size: 15px;
            font-weight: bold;

            ${mobile(({ setAutomaticDesignBasedSize }) => css`
              font-size: ${setAutomaticDesignBasedSize(15, 15)};
            `)}
          `}
        >
          外壁と屋根の工事
        </p>
      </div>
      <div
        css={css`
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 0 10px;

          ${mobile(({ setAutomaticDesignBasedSize }) => css`
            gap: 0 ${setAutomaticDesignBasedSize(10, 10)};
          `)}
        `}
      >
        {CONSTRUCTION_TYPE_LIST.map((companyInfomation) => {
          const { id, text } = companyInfomation;

          return (
            <button
              key={id}
              value={text}
              onClick={onApplyHandler}
              id={`ga_event_${KEY_NAME}_button_${id}`}
              css={css`
                color: #041156;
                font-size: 14px;
                font-weight: bold;
                text-align: center;
                padding: 24px 1em;
                background-color: #fff;
                border: 1px solid #041156;
                border-radius: 8px;

                ${mobile(({ setAutomaticDesignBasedSize }) => css`
                  font-size: ${setAutomaticDesignBasedSize(14, 13)};
                  padding: ${setAutomaticDesignBasedSize(24, 19)} 0;
                `)}

                &:hover {
                  background-color: #fff7c9;
                }
              `}
            >
              {text}
            </button>
          );
        })}
      </div>
    </div>
  );
};
